const $ = require('jquery');

/**
 * calcOberkronenWassermenge
 * @param path
 */
window.calcOberkronenWassermenge = function(path) {
  const oberkronenDurchmesserDuese = $('#bewaesserungsanlage-oberkronenDurchmesserDuese').val();
  const oberkronenDruckDuese = $('#bewaesserungsanlage-oberkronenDruckDuese').val();
  const oberkronenAnzahlRegner = $('#bewaesserungsanlage-oberkronenAnzahlRegner').val();
  const beregneteFlaeche = $('input#beregneteFlaeche').val();

  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      oberkronenberegnung: true,
      oberkronenDurchmesserDuese: oberkronenDurchmesserDuese,
      oberkronenAnzahlRegner: oberkronenAnzahlRegner,
      oberkronenDruckDuese: oberkronenDruckDuese,
      beregneteFlaeche: beregneteFlaeche,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-oberkronenAusgebrachteWassermengeMm').val(response['oberkronenAusgebrachteWassermengeMm']);
      $('#bewaesserungsanlage-oberkronenAusgebrachteWassermengeLh').val(response['oberkronenAusgebrachteWassermengeLh']);
    },
  });
};

/**
 * calcTropfWassermenge
 * @param path
 */
window.calcTropfWassermenge = function(path) {
  const tropfWassermengeProTropfer = $('#bewaesserungsanlage-tropfWassermengeProTropfer').val();
  const tropfAnzahlTropfer = $('#bewaesserungsanlage-tropfAnzahlTropfer').val();
  const beregneteFlaeche = $('input#beregneteFlaeche').val();

  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      tropfer: true,
      anzahlTropfer: tropfAnzahlTropfer,
      tropfWassermengeProTropfer: tropfWassermengeProTropfer,
      beregneteFlaeche: beregneteFlaeche,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-tropfAusgebrachteWassermengeMm').val(response['tropfAusgebrachteWassermengeMm']);
      $('#bewaesserungsanlage-tropfAusgebrachteWassermengeLh').val(response['tropfAusgebrachteWassermengeLh']);
    },
  });
};

/**
 * updateDruckDuese
 * @param path
 * @param oberkronenDurchmesserDuese
 */
window.updateDruckDuese = function(path, oberkronenDurchmesserDuese) {
  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      updateDruckDuese: true,
      oberkronenDurchmesserDuese: oberkronenDurchmesserDuese,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      if (response['success'] === true) {
        const oberkronenAnzahlRegner = $('#bewaesserungsanlage-oberkronenAnzahlRegner').val();
        const beregneteFlaeche = $('input#beregneteFlaeche').val();

        $('#bewaesserungsanlage-oberkronenDruckDuese').html(response['html']);
        calcOberkronenWassermenge(path, oberkronenDurchmesserDuese, oberkronenAnzahlRegner, response['firstElement'], beregneteFlaeche);
      }
    },
  });
};

/**
 * calcAnzahlRegner
 * @param path
 */
window.calcAnzahlRegner = function(path) {
  const oberkronenAbstandZwReihen = $('#bewaesserungsanlage-oberkronenAbstandZwReihen').val();
  const oberkronenAbstandInReihe = $('#bewaesserungsanlage-oberkronenAbstandInReihe').val();
  const beregneteFlaeche = $('input#beregneteFlaeche').val();

  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      updateAnzahlRegner: true,
      beregneteFlaeche: beregneteFlaeche,
      oberkronenAbstandZwReihen: oberkronenAbstandZwReihen,
      oberkronenAbstandInReihe: oberkronenAbstandInReihe,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-oberkronenAnzahlRegnerBerechnet').val(response['anzahlRegnerBerechnet']);
    },
  });
};

/**
 * copyAnzahlRegner
 */
window.copyAnzahlRegner = function() {
  const anzahlRegnerBerechnet = $('#bewaesserungsanlage-oberkronenAnzahlRegnerBerechnet').val();
  $('#bewaesserungsanlage-oberkronenAnzahlRegner').val(anzahlRegnerBerechnet);
  calcOberkronenWassermenge(pathToAjax);
  $('#hinweis-flaechen').addClass('hide-mobile');
};

/**
 * calcAnzahlTropfer
 * @param path
 * @param bewaesserungsanlageID
 */
window.calcAnzahlTropfer = function(path, bewaesserungsanlageID) {
  const tropfAbstandTropfer = $('#bewaesserungsanlage-tropfAbstandTropfer').val();
  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      updateAnzahlTropfer: true,
      anlageID: bewaesserungsanlageID,
      tropfAbstandTropfer: tropfAbstandTropfer,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-tropfAnzahlTropfer').val(response['anzahlTropfer']);
      calcTropfWassermenge(path);
    },
  });
};

/**
 * calcAnzahlTropferMicrojet
 * @param path
 * @param bewaesserungsanlageID
 */
window.calcAnzahlTropferMicrojet = function(path, bewaesserungsanlageID) {
  const tropfAbstandTropfer = $('#bewaesserungsanlage-microjetAbstandTropfer').val();
  const sectionIDs = $('#bewaesserungsanlage-selectedSectionIDs').val();
  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      updateAnzahlTropfer: true,
      anlageID: bewaesserungsanlageID,
      tropfAbstandTropfer: tropfAbstandTropfer,
      sectionIDs: sectionIDs,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-microjetAnzahlTropfer').val(response['anzahlTropfer']);
      calcMicrojetWassermenge(path);
    },
  });
};

/**
 * calcMicrojetWassermenge
 *
 * @param path
 */
window.calcMicrojetWassermenge = function(path) {
  const tropfWassermengeProTropfer = $('#bewaesserungsanlage-microjetWassermengeProTropfer').val();
  const tropfAnzahlTropfer = $('#bewaesserungsanlage-microjetAnzahlTropfer').val();
  const beregneteFlaeche = $('input#beregneteFlaeche').val();

  $.ajax({
    url: path,
    type: 'post',
    dataType: 'json',
    data: {
      tropfer: true,
      anzahlTropfer: tropfAnzahlTropfer,
      tropfWassermengeProTropfer: tropfWassermengeProTropfer,
      beregneteFlaeche: beregneteFlaeche,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function(response) {
      $('#bewaesserungsanlage-microjetAusgebrachteWassermengeMm').val(response['tropfAusgebrachteWassermengeMm']);
      $('#bewaesserungsanlage-microjetAusgebrachteWassermengeLh').val(response['tropfAusgebrachteWassermengeLh']);
    },
  });
};

window.updateBewaesserungssystemData = function(pathToAjax) {
  let flaeche = bewaesserungsanlagen_setAccordionField('flaeche');
  let flaecheSaved = $('input#savedBeregneteFlaeche').val();

  if (flaeche !== parseFloat(flaecheSaved)) {
    $('#hinweis-flaechen').removeClass('hide-mobile');
  } else {
    $('#hinweis-flaechen').addClass('hide-mobile');
  }

  $('input#beregneteFlaeche').val(flaeche);
  const bewaesserungsanlageData = $('#bewaesserungsanlageData');
  if (bewaesserungsanlageData.find('#bewaesserungsanlage-oberkronenAnzahlRegnerBerechnet').length > 0) {
    calcAnzahlRegner(pathToAjax);
    let durchmesserDuese = $('#bewaesserungsanlage-oberkronenDurchmesserDuese').val() ?? 0;
    updateDruckDuese(pathToAjax, durchmesserDuese);
  }
  if (bewaesserungsanlageData.find('#bewaesserungsanlage-tropfAnzahlTropfer').length > 0) {
    calcTropfWassermenge(pathToAjax);
  }
  if (bewaesserungsanlageData.find('#bewaesserungsanlage-microjetAnzahlTropfer').length > 0) {
    calcMicrojetWassermenge(pathToAjax);
  }
};

/**
 * bewaesserungsanlagen_bindChangingFields
 * @param pathToAjax
 * @param bewaesserungsanlageID
 */
window.bewaesserungsanlagen_bindChangingFields = function(pathToAjax, bewaesserungsanlageID) {
  $('#bewaesserungsanlage-oberkronenDurchmesserDuese').on('change', function() {
    updateDruckDuese(pathToAjax, $(this).val());
  });

  $('#bewaesserungsanlage-oberkronenDruckDuese').on('change', function() {
    calcOberkronenWassermenge(pathToAjax);
  });

  $('#bewaesserungsanlage-oberkronenAnzahlRegner').on('change', function() {
    calcOberkronenWassermenge(pathToAjax);
  });

  $('#bewaesserungsanlage-oberkronenAbstandZwReihen').on('change', function() {
    calcAnzahlRegner(pathToAjax);
  });

  $('#bewaesserungsanlage-oberkronenAbstandInReihe').on('change', function() {
    calcAnzahlRegner(pathToAjax);
  });

  $('#bewaesserungsanlage-tropfAbstandTropfer').on('change', function() {
    calcAnzahlTropfer(pathToAjax, bewaesserungsanlageID);
  });

  $('#bewaesserungsanlage-tropfWassermengeProTropfer').on('change', function() {
    calcTropfWassermenge(pathToAjax);
  });

  $('#bewaesserungsanlage-microjetAbstandTropfer').on('change', function() {
    calcAnzahlTropferMicrojet(pathToAjax, bewaesserungsanlageID);
  });

  $('#bewaesserungsanlage-microjetWassermengeProTropfer').on('change', function() {
    calcMicrojetWassermenge(pathToAjax);
  });
};

/**
 * deleteBewaesserungsanlage
 * @param bewaesserungsanlagenID
 * @param parentLink
 */
window.deleteBewaesserungsanlage = function(bewaesserungsanlagenID, parentLink) {
  $.ajax({
    url: pathToAjax,
    type: 'post',
    dataType: 'json',
    data: {
      bewaesserungsanlagenID: bewaesserungsanlagenID,
      deleteBewaesserungsanlage: true,
    },
    beforeSend: function() {
      insertAutoLoader($('.modal-content'));
    },
    success: function() {
      window.open(parentLink, '_self');
    },
  });
};

/**
 * bewaesserungsanlagen_sortWithParameter
 * @param sort
 * @param uid
 */
window.bewaesserungsanlagen_sortWithParameter = function(sort, uid) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const activeButtons = $('.active-buttons');
  if (activeButtons.length > 0) {
    activeButtons.removeClass('active');

    const firstLevelButton = $('#show-first-level');
    if (sort === 'betrieb') {
      firstLevelButton.html('<i class="material-icons">check</i>' + LANG_STRINGS.anlagen);
    } else if (sort === 'sorte') {
      firstLevelButton.html('<i class="material-icons">check</i>' + LANG_STRINGS.betriebe);
    }
  }

  const ListFlaechenBewaesserungsanlagen = new AjaxItem('flaechenBewaesserungsanlagen', {}, {}, 'betriebsdaten');
  ListFlaechenBewaesserungsanlagen.poster({
    checked: checked,
    sortby: sort,
    uid: uid,
  });
};

/**
 * bewaesserungsanlagen_showHideLockedDataset
 * @param currentElement
 * @param uid
 */
window.bewaesserungsanlagen_showHideLockedDataset = function(currentElement, uid) {
  const checked = $('div[data-section-uid]').has('input:checked').map(function() {
    return parseInt($(this).data('section-uid'));
  }).get();

  const ListFlaechenBewaesserungsanlagen = new AjaxItem('flaechenBewaesserungsanlagen', {}, {}, 'betriebsdaten');
  ListFlaechenBewaesserungsanlagen.poster({
    checked: checked,
    uid: uid,
    showHideLockedDataset: 1,
  });

  if ($(currentElement).find('span').hasClass('show-txt-0')) {
    $(currentElement).find('span').html(LANG_STRINGS.bereitsZugeordneteAbschnitteAusblenden);
    $(currentElement).find('span').removeClass('show-txt-0').addClass('show-txt-1');
  } else {
    $(currentElement).find('span').html(LANG_STRINGS.bereitsZugeordneteAbschnitteEinblenden);
    $(currentElement).find('span').removeClass('show-txt-1').addClass('show-txt-0');
  }
};

/**
 * bewaesserungsanlagen_setAccordionField
 * @param type
 * @returns {string|*}
 */
window.bewaesserungsanlagen_setAccordionField = function(type) {
  if (type === 'bewaesserungType') {
    const inputChecked = $('.bewaesserungssystem').find('input[type="radio"]:checked');
    return inputChecked.closest('label').find('.label').text();
  }

  if (type === 'name') {
    return document.getElementById('bewaesserungsanlage-name').value;
  }

  if (type === 'flaeche') {
    let dataSectionID = $('[data-section-uid]');
    let sumFlaeche = 0;
    dataSectionID.has('input:checked').map(function() {
      sumFlaeche += Number($(this).find('input[name="flaeche"]').val());
    });
    return sumFlaeche;
  }

  if (type === 'regner') {
    let oberkroneRegner = typeof(document.getElementById('bewaesserungsanlage-oberkronenAnzahlRegner')) !== 'undefined' ? document.getElementById('bewaesserungsanlage-oberkronenAnzahlRegner').value : 0;
    let tropfTropfer = document.getElementById('bewaesserungsanlage-tropfAnzahlTropfer') !== null  ? document.getElementById('bewaesserungsanlage-tropfAnzahlTropfer').value : 0;
    let microjetTropfer = document.getElementById('bewaesserungsanlage-microjetAnzahlTropfer') !== null ? document.getElementById('bewaesserungsanlage-microjetAnzahlTropfer').value : 0;

    let text = '';
    if (oberkroneRegner > 0) {
      text += '(' + oberkroneRegner + ' '+LANG_REGNER;
    }
    if (tropfTropfer > 0) {
      if (text.length === 0) {
        text += '(';
      } else {
        text += ' | ';
      }
      text += tropfTropfer + ' '+LANG_TROPFER;
    }
    if (microjetTropfer > 0) {
      if (text.length === 0) {
        text += '(';
      } else {
        text += ' | ';
      }
      text += microjetTropfer + ' '+LANG_TROPFER;
    }
    if (text.length > 0) {
      text += ')';
    }
    return text;
  }

};

/**
 * bewaesserungsanlagen_bindSetAdditionalText
 */
window.bewaesserungsanlagen_bindSetAdditionalText = function() {
  const bewaesserungsanlagenLayout = $('#bewaesserungsanlageData');
  bewaesserungsanlagenLayout.find('div.accordion__item__title__additional').each(function() {
    // Set Bewässerungsart
    if ($(this).find('.sub-bewaesserung-type').length > 0) {
      $(this).find('.sub-bewaesserung-type').html(bewaesserungsanlagen_setAccordionField('bewaesserungType'));
    }

    // Set Name
    if ($(this).find('.sub-name').length > 0) {
      $(this).find('.sub-name').html(bewaesserungsanlagen_setAccordionField('name'));
    }

    // Set Fläche
    if ($(this).find('.sub-flaeche').length > 0) {
      let flaeche = bewaesserungsanlagen_setAccordionField('flaeche');

      $(this).find('.sub-flaeche').html(numberFormat(flaeche / 10000, DECIMAL_PLACES_FLAECHE_HA_GUI, ',', '.') + ' ha');
      $(this).find('input#beregneteFlaeche').val(flaeche);
    }

    // Set Regner
    if ($(this).find('.sub-regner').length > 0) {
      let regner = bewaesserungsanlagen_setAccordionField('regner');
      $(this).find('.sub-regner').html(regner);
    }
  });

  bewaesserungsanlagenLayout.find('div.accordion__item__title__additional').removeClass('display-none');
};

/**
 * bewaesserungsanlagen_bindRemoveLastStep
 */
window.bewaesserungsanlagen_bindRemoveLastStep = function() {
  $('form#bewaesserungsanlageData').find('input, select, textarea').change(function() {
    bewaesserungsanlagen_removeLastStep();
  });
};

/**
 * bewaesserungsanlagen_bindChangingBewaesserungssystem
 * @param bewaesserungsanlageID
 */
window.bewaesserungsanlagen_bindChangingBewaesserungssystem = function(bewaesserungsanlageID) {
  // Change Culture
  $('.bewaesserungssystem').find('input[type=radio]').on('click', function(event) {
    const newValue = $(this).val();
    const oldValue = $('#bewaesserungssystemID').val();
    if (oldValue !== newValue) {
      ajaxDialog(BASE_PATH + 'ajax/dialog/betriebsdaten/ajax.editEingabeBewaesserungssystemChange?bewaesserungssystemID=' + newValue + '&bewaesserungsanlageID=' + bewaesserungsanlageID + '&oldValue=' + oldValue);
    }
  });
};

/**
 * bewaesserungsanlagen_removeLastStep
 */
window.bewaesserungsanlagen_removeLastStep = function() {
  bewaesserungsanlagen_bindSetAdditionalText();
};

// Document-Ready
$(function() {
  bewaesserungsanlagen_bindRemoveLastStep();
});